(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[17],{

/***/ "+WQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Button */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BatchButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Box; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Center; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SeparationLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SeparationHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RichText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LinkText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Space; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Tag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DataSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AntdTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EditBtn; });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0lfv");
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3S7+");



var Button = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].button.withConfig({
  displayName: "common__Button",
  componentId: "sc-7sgkc0-0"
})(["background:", ";color:", ";font-size:1em;margin:1em;padding:0.25em 1em;border:2px solid palevioletred;border-radius:3px;"], function (props) {
  return props.primary ? 'palevioletred' : 'white';
}, function (props) {
  return props.primary ? 'white' : 'palevioletred';
});
var BatchButton = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__BatchButton",
  componentId: "sc-7sgkc0-1"
})(["width:117px;height:32px;display:flex;justify-content:center;align-items:center;border:1px solid #046eff;color:#046eff;font-size:14px;cursor:pointer;&:hover{opacity:0.8;}"]);
var Box = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Box",
  componentId: "sc-7sgkc0-2"
})(["font-size:0;width:", ";height:", ";margin:", ";padding:", ";", " ", " ", ""], function (_ref) {
  var width = _ref.width;
  return "".concat(typeof width === 'number' ? "".concat(width, "px") : width);
}, function (_ref2) {
  var height = _ref2.height;
  return "".concat(typeof height === 'number' ? "".concat(height, "px") : height);
}, function (_ref3) {
  var _ref3$mTop = _ref3.mTop,
      mTop = _ref3$mTop === void 0 ? 0 : _ref3$mTop,
      _ref3$mRight = _ref3.mRight,
      mRight = _ref3$mRight === void 0 ? 0 : _ref3$mRight,
      _ref3$mBottom = _ref3.mBottom,
      mBottom = _ref3$mBottom === void 0 ? 0 : _ref3$mBottom,
      _ref3$mLeft = _ref3.mLeft,
      mLeft = _ref3$mLeft === void 0 ? 0 : _ref3$mLeft;
  return "".concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(mTop), " ").concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(mRight), " ").concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(mBottom), " ").concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(mLeft));
}, function (_ref4) {
  var _ref4$pTop = _ref4.pTop,
      pTop = _ref4$pTop === void 0 ? 0 : _ref4$pTop,
      _ref4$pRight = _ref4.pRight,
      pRight = _ref4$pRight === void 0 ? 0 : _ref4$pRight,
      _ref4$pBottom = _ref4.pBottom,
      pBottom = _ref4$pBottom === void 0 ? 0 : _ref4$pBottom,
      _ref4$pLeft = _ref4.pLeft,
      pLeft = _ref4$pLeft === void 0 ? 0 : _ref4$pLeft;
  return "".concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(pTop), " ").concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(pRight), " ").concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(pBottom), " ").concat(Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(pLeft));
}, function (_ref5) {
  var isPositioned = _ref5.isPositioned,
      top = _ref5.top,
      right = _ref5.right,
      bottom = _ref5.bottom,
      left = _ref5.left;
  return isPositioned && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["position:absolute;top:", ";right:", ";bottom:", ";left:", ";"], Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(top), Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(right), Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(bottom), Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(left));
}, function (_ref6) {
  var isRelative = _ref6.isRelative;
  return isRelative && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["position:relative;"]);
}, function (_ref7) {
  var isCursor = _ref7.isCursor;
  return isCursor && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["cursor:pointer;"]);
});
var Row = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Row",
  componentId: "sc-7sgkc0-3"
})(["display:flex;align-items:", ";justify-content:", ";flex-direction:", ";", " ", ""], function (_ref8) {
  var _ref8$align = _ref8.align,
      align = _ref8$align === void 0 ? 'center' : _ref8$align;
  return align;
}, function (_ref9) {
  var justify = _ref9.justify;
  return justify;
}, function (_ref10) {
  var _ref10$direction = _ref10.direction,
      direction = _ref10$direction === void 0 ? 'row' : _ref10$direction;
  return direction;
}, function (_ref11) {
  var wrap = _ref11.wrap,
      height = _ref11.height;
  return wrap && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["flex-wrap:wrap;align-content:space-between;height:", "px;"], height);
}, function (_ref12) {
  var width = _ref12.width;
  return width && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["width:", ";"], width);
});
var Center = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Center",
  componentId: "sc-7sgkc0-4"
})(["display:flex;justify-content:center;align-items:center;"]);
var SeparationLine = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__SeparationLine",
  componentId: "sc-7sgkc0-5"
})(["width:1px;height:27px;background:rgba(218,218,218,0.5);"]);
var SeparationHorizontal = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__SeparationHorizontal",
  componentId: "sc-7sgkc0-6"
})(["width:100%;height:1px;background:rgba(218,218,218,0.5);margin:", ";"], function (_ref13) {
  var margin = _ref13.margin;
  return margin;
});
var Ellipsis = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Ellipsis",
  componentId: "sc-7sgkc0-7"
})(["", ""], function (_ref14) {
  var lines = _ref14.lines,
      width = _ref14.width;
  return lines ? Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:", ";text-overflow:ellipsis;overflow:hidden;"], lines) : Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["width:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* r */ "v"])(width));
});
var RichText = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__RichText",
  componentId: "sc-7sgkc0-8"
})(["flex:1;margin-bottom:100px;& img{max-width:100%;height:auto;object-fit:contain;}& p{overflow:hidden;line-height:22px;}"]);
var LinkText = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__LinkText",
  componentId: "sc-7sgkc0-9"
})(["font-size:12px;color:#006cff;cursor:pointer;"]);
var Space = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Space",
  componentId: "sc-7sgkc0-10"
})(["display:inline-flex;align-items:center;& >:not(:last-child){margin-right:", ";}"], function (_ref15) {
  var _ref15$spacing = _ref15.spacing,
      spacing = _ref15$spacing === void 0 ? 10 : _ref15$spacing;
  return "".concat(spacing, "px");
});
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Tag",
  componentId: "sc-7sgkc0-11"
})(["height:30px;display:flex;justify-content:center;align-items:center;padding:0 10px;border-radius:5px;border:1px solid transparent;font-size:13px;font-weight:bold;", ""], function (_ref16) {
  var type = _ref16.type;
  var map = new Map();

  switch (type) {
    case 'purple':
      map.set('purple', {
        color: '#6F71AD',
        borderColor: '#D8DDF2',
        bgColor: '#E6EBFE'
      });
      break;

    case 'green':
      map.set('green', {
        color: '#45B08A',
        borderColor: '#D3F2E3',
        bgColor: '#E3FFF1'
      });
      break;

    case 'blue':
      map.set('blue', {
        color: '#2E96D8',
        borderColor: '#D5EBF2',
        bgColor: '#E7F9FF'
      });
      break;
  }

  return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["color:", ";background-color:", ";border-color:", ";"], map.get(type).color, map.get(type).bgColor, map.get(type).borderColor);
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].span.withConfig({
  displayName: "common__Text",
  componentId: "sc-7sgkc0-12"
})(["margin-bottom:", "px;margin-top:", "px;margin-left:", "px;margin-right:", "px;", " ", " ", " ", " ", " ", " ", " ", " ", ";"], function (_ref17) {
  var marginBottom = _ref17.marginBottom;
  return marginBottom;
}, function (_ref18) {
  var marginTop = _ref18.marginTop;
  return marginTop;
}, function (_ref19) {
  var marginLeft = _ref19.marginLeft;
  return marginLeft;
}, function (_ref20) {
  var marginRight = _ref20.marginRight;
  return marginRight;
}, function (_ref21) {
  var pointerEvents = _ref21.pointerEvents;
  return pointerEvents && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["pointer-events:none;"]);
}, function (_ref22) {
  var center = _ref22.center;
  return center && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["text-align:center;"]);
}, function (_ref23) {
  var width = _ref23.width;
  return width && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["width:", ";"], width);
}, function (_ref24) {
  var _ref24$fontSize = _ref24.fontSize,
      fontSize = _ref24$fontSize === void 0 ? 14 : _ref24$fontSize;
  return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["font-size:", ";"], typeof fontSize === 'string' ? fontSize : "".concat(fontSize, "px"));
}, function (_ref25) {
  var isBold = _ref25.isBold;
  return isBold && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["font-weight:bold;"]);
}, function (_ref26) {
  var lineHeight = _ref26.lineHeight;
  return lineHeight && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["line-height:", ";"], lineHeight);
}, function (_ref27) {
  var isCursor = _ref27.isCursor;
  return isCursor && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["cursor:pointer;"]);
}, function (_ref28) {
  var hasUnderline = _ref28.hasUnderline;
  return hasUnderline && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["text-decoration:underline;"]);
}, function (_ref29) {
  var type = _ref29.type,
      color = _ref29.color;
  if (color) return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["color:", ";"], color);
  var map = new Map();

  switch (type) {
    case 'link':
      map.set(type, {
        color: '#459FF3',
        cursor: 'pointer'
      });
      break;

    case 'delete':
      map.set(type, {
        color: '#EE5454',
        cursor: 'pointer'
      });
      break;

    case 'warning':
      map.set(type, {
        color: '#F97E24',
        cursor: 'default'
      });
      break;

    case 'normal':
      map.set(type, {
        color: '#999999',
        cursor: 'default'
      });
      break;
  }

  return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["color:", ";cursor:", ";"], map.get(type).color, map.get(type).cursor);
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__Container",
  componentId: "sc-7sgkc0-13"
})(["flex:1;display:flex;flex-direction:column;"]);
var DataSource = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__DataSource",
  componentId: "sc-7sgkc0-14"
})(["font-size:12px;cursor:default;font-family:Microsoft YaHei;font-weight:400;color:#999999;text-align:right;", " ", ""], function (_ref30) {
  var type = _ref30.type;
  return type === 'report' && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["padding:0 20px;color:rgba(218,227,255,0.4);"]);
}, function (_ref31) {
  var noPadding = _ref31.noPadding;
  return noPadding && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["padding:0px;"]);
});
var AntdTooltip = Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"])(antd__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]).withConfig({
  displayName: "common__AntdTooltip",
  componentId: "sc-7sgkc0-15"
})([""]);
var EditBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "d"].div.withConfig({
  displayName: "common__EditBtn",
  componentId: "sc-7sgkc0-16"
})(["cursor:pointer;font-size:0;margin-left:14px;opacity:1;", ""], function (_ref32) {
  var opacity = _ref32.opacity;
  return !opacity && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "c"])(["cursor:default;opacity:0;"]);
});

/***/ }),

/***/ "1ccW":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "5fIB":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("7eYB");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "98FW":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "Aiso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dQHF")


/***/ }),

/***/ "UWYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.__esModule=true;exports.imageConfigDefault=exports.VALID_LOADERS=void 0;const VALID_LOADERS=['default','imgix','cloudinary','akamai'];exports.VALID_LOADERS=VALID_LOADERS;const imageConfigDefault={deviceSizes:[640,750,828,1080,1200,1920,2048,3840],imageSizes:[16,32,48,64,96,128,256,384],path:'/_next/image',loader:'default',domains:[]};exports.imageConfigDefault=imageConfigDefault;
//# sourceMappingURL=image-config.js.map

/***/ }),

/***/ "dEHY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toBase64 = toBase64;
/**
* Isomorphic base64 that works on the server and client
*/

function toBase64(str) {
  if (false) {} else {
    return window.btoa(str);
  }
}

/***/ }),

/***/ "dQHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("zoAU");

var _toConsumableArray = __webpack_require__("mPvQ");

var _interopRequireDefault = __webpack_require__("AroE");

exports.__esModule = true;
exports.default = Image;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("98FW"));

var _extends2 = _interopRequireDefault(__webpack_require__("1ccW"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _toBase = __webpack_require__("dEHY");

var _imageConfig = __webpack_require__("UWYU");

var _useIntersection = __webpack_require__("vNVm");

if (false) {}

var VALID_LOADING_VALUES = ['lazy', 'eager', undefined];
var loaders = new Map([['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['default', defaultLoader]]);
var VALID_LAYOUT_VALUES = ['fill', 'fixed', 'intrinsic', 'responsive', undefined];

var _ref2 = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"} || _imageConfig.imageConfigDefault,
    configDeviceSizes = _ref2.deviceSizes,
    configImageSizes = _ref2.imageSizes,
    configLoader = _ref2.loader,
    configPath = _ref2.path,
    configDomains = _ref2.domains; // sort smallest to largest


var allSizes = [].concat(_toConsumableArray(configDeviceSizes), _toConsumableArray(configImageSizes));
configDeviceSizes.sort(function (a, b) {
  return a - b;
});
allSizes.sort(function (a, b) {
  return a - b;
});

function getWidths(width, layout) {
  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: configDeviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set([width, width * 2, width * 3].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function callLoader(loaderProps) {
  var load = loaders.get(configLoader);

  if (load) {
    return load((0, _extends2.default)({
      root: configPath
    }, loaderProps));
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(configLoader));
}

function generateImgAttrs(_ref3) {
  var src = _ref3.src,
      unoptimized = _ref3.unoptimized,
      layout = _ref3.layout,
      width = _ref3.width,
      quality = _ref3.quality,
      sizes = _ref3.sizes;

  if (unoptimized) {
    return {
      src: src
    };
  }

  var _getWidths = getWidths(width, layout),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  var srcSet = widths.map(function (w, i) {
    return "".concat(callLoader({
      src: src,
      quality: quality,
      width: w
    }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
  }).join(', ');

  if (!sizes && kind === 'w') {
    sizes = '100vw';
  }

  src = callLoader({
    src: src,
    quality: quality,
    width: widths[last]
  });
  return {
    src: src,
    sizes: sizes,
    srcSet: srcSet
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function Image(_ref) {
  var src = _ref.src,
      sizes = _ref.sizes,
      _ref$unoptimized = _ref.unoptimized,
      unoptimized = _ref$unoptimized === void 0 ? false : _ref$unoptimized,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority,
      loading = _ref.loading,
      className = _ref.className,
      quality = _ref.quality,
      width = _ref.width,
      height = _ref.height,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition,
      all = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "objectFit", "objectPosition"]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';
  var unsized = false;

  if ('unsized' in rest) {
    unsized = Boolean(rest.unsized); // Remove property so it's not spread into image:

    delete rest['unsized'];
  } else if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread into image:

    delete rest['layout'];
  }

  if (false) {}

  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src && src.startsWith('data:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  var _ref4 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px',
    disabled: !isLazy
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      setRef = _ref5[0],
      isIntersected = _ref5[1];

  var isVisible = !isLazy || isIntersected;
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);
  var wrapperStyle;
  var sizerStyle;
  var sizerSvg;
  var imgStyle = {
    visibility: isVisible ? 'visible' : 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };

  if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined' && layout !== 'fill') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle = {
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        display: 'block',
        boxSizing: 'border-box',
        paddingTop: paddingTop
      };
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle = {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        maxWidth: '100%'
      };
      sizerSvg = "<svg width=\"".concat(widthInt, "\" height=\"").concat(heightInt, "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle = {
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'inline-block',
        position: 'relative',
        width: widthInt,
        height: heightInt
      };
    }
  } else if (typeof widthInt === 'undefined' && typeof heightInt === 'undefined' && layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle = {
      display: 'block',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      boxSizing: 'border-box',
      margin: 0
    };
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes
    });
  }

  if (unsized) {
    wrapperStyle = undefined;
    sizerStyle = undefined;
    imgStyle = undefined;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: wrapperStyle
  }, sizerStyle ? /*#__PURE__*/_react.default.createElement("div", {
    style: sizerStyle
  }, sizerSvg ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxWidth: '100%',
      display: 'block'
    },
    alt: "",
    "aria-hidden": true,
    role: "presentation",
    src: "data:image/svg+xml;base64,".concat((0, _toBase.toBase64)(sizerSvg))
  }) : null) : null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    className: className,
    ref: setRef,
    style: imgStyle
  })));
} //BUILT IN LOADERS


function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

function imgixLoader(_ref6) {
  var root = _ref6.root,
      src = _ref6.src,
      width = _ref6.width,
      quality = _ref6.quality;
  // Demo: https://static.imgix.net/daisy.png?format=auto&fit=max&w=300
  var params = ['auto=format', 'fit=max', 'w=' + width];
  var paramsString = '';

  if (quality) {
    params.push('q=' + quality);
  }

  if (params.length) {
    paramsString = '?' + params.join('&');
  }

  return "".concat(root).concat(normalizeSrc(src)).concat(paramsString);
}

function akamaiLoader(_ref7) {
  var root = _ref7.root,
      src = _ref7.src,
      width = _ref7.width;
  return "".concat(root).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref8) {
  var root = _ref8.root,
      src = _ref8.src,
      width = _ref8.width,
      quality = _ref8.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(root).concat(paramsString).concat(normalizeSrc(src));
}

function defaultLoader(_ref9) {
  var root = _ref9.root,
      src = _ref9.src,
      width = _ref9.width,
      quality = _ref9.quality;

  if (false) { var parsedSrc, missingValues; }

  return "".concat(root, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

/***/ }),

/***/ "kG2m":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "mPvQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("5fIB");

var iterableToArray = __webpack_require__("rlHP");

var unsupportedIterableToArray = __webpack_require__("KckH");

var nonIterableSpread = __webpack_require__("kG2m");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "rlHP":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "vNVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("zoAU");

var _interopRequireDefault = __webpack_require__("AroE");

exports.__esModule = true;
exports.useIntersection = useIntersection;

var _react = __webpack_require__("q1tI");

var _requestIdleCallback = _interopRequireDefault(__webpack_require__("0G5g"));

var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

function useIntersection(_ref) {
  var rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react.useRef)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      visible = _ref3[0],
      setVisible = _ref3[1];

  var setRef = (0, _react.useCallback)(function (el) {
    if (unobserve.current) {
      unobserve.current();
      unobserve.current = undefined;
    }

    if (isDisabled || visible) return;

    if (el && el.tagName) {
      unobserve.current = observe(el, function (isVisible) {
        return isVisible && setVisible(isVisible);
      }, {
        rootMargin: rootMargin
      });
    }
  }, [isDisabled, rootMargin, visible]);
  (0, _react.useEffect)(function () {
    if (!hasIntersectionObserver) {
      if (!visible) (0, _requestIdleCallback.default)(function () {
        return setVisible(true);
      });
    }
  }, [visible]);
  return [setRef, visible];
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
    }
  };
}

var observers = new Map();

function createObserver(options) {
  var id = options.rootMargin || '';
  var instance = observers.get(id);

  if (instance) {
    return instance;
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  observers.set(id, instance = {
    id: id,
    observer: observer,
    elements: elements
  });
  return instance;
}

/***/ })

}]);